import Api from "./Api";

export const FALLBACK_PRICES = {
    individual: {
        monthly: 650,
        annual: 6000,
    },
    group: {
        annual: 30000,
    },
    enterprise: {
        annual: 50000,
    },
};

export async function getSubscriptionPrices() {
    try {
        const response = await Api.get("/payment/prices");
        return response.data;
    } catch (error) {
        console.warn("Using fallback subscription prices", error);
        return FALLBACK_PRICES;
    }
}

export function formatPrice(pence) {
    const amount = Number(pence || 0) / 100;
    return amount.toLocaleString("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2,
    });
}
